import autobind from "autobind-decorator";
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";

import {
    CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, WithStyles
} from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

import API from "./API";
import Button from "./Button";
import Text from "./Text";

type ClassNames = "container" | "loading" | "form" | "btn" | "input" | "link";

const apparence: {} = {
    apparence: "none",
    WebkitAppearance: "none",
    MozAppearance: "none"
};

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
    },
    loading: {
        color: "white"
    },
    form: {
        display: "flex",
        marginTop: theme.spacing.unit * 2
    },
    input: {
        margin: 0,
        flexGrow: 1,
        boxSizing: "border-box",
        boxShadow: "none",
        borderWidth: 2,
        borderRightWidth: 0,
        borderStyle: "solid",
        borderColor: theme.palette.grey[300],
        borderRadius: 5,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        ...theme.typography.body1,
        padding: theme.spacing.unit * 2,
        "&:focus": {
            borderColor: theme.palette.primary[500],
            outlineWidth: 0,
            appearance: "none",
            outline: 0
        },
        "&::-webkit-input-placeholder": {
            color: theme.palette.grey[300]
        },
        "&::-moz-placeholder": {
            color: theme.palette.grey[300]
        },
        "&:-moz-placeholder": {
            color: theme.palette.grey[300]
        },
        "&::-ms-input-placeholder": {
            color: theme.palette.grey[300]
        }
    },
    btn: {
        margin: 0,
        boxSizing: "border-box",
        ...theme.typography.body1,
        backgroundColor: theme.palette.primary[500],
        padding: theme.spacing.unit * 2,
        color: "white",
        borderStyle: "solid",
        borderWidth: 2,
        borderColor: theme.palette.primary[500],
        borderRadius: 0,
        borderTopRightRadius: 5,
        borderBottomRightRadius: 5,
    },
    link: {
        color: theme.typography.body1.color
    }
});

interface GithubInviteProps {
    accessKey: string;
    email: string;
    repo: string;
}

@observer
class GithubInvite extends React.Component<WithStyles<ClassNames> & GithubInviteProps> {

    @observable public isLoading = false;
    @observable public isDone = false;
    @observable public error = false;
    @observable public username: string = "";

    @action
    public loading(loading: boolean) {
        if (loading) {
            this.error = false;
        }
        this.isLoading = loading;
    }

    @action
    public setError() {
        this.error = true;
    }

    @action
    public done() {
        this.isLoading = false;
        this.isDone = true;
        this.username = "";
    }

    @autobind @action
    public closeDialog() {
        this.isDone = false;
    }

    @autobind
    public async submit() {
        const {accessKey: key, email, repo} = this.props;
        const {username} = this;
        this.loading(true);
        const response = await API.addGithubCollaborator({ email, key, username, repo });
        if (!response.ok) {
            this.setError();
        }
        this.done();
    }

    @autobind @action
    public setUsername(e: React.ChangeEvent<HTMLInputElement>) {
        this.username = e.target.value;
    }

    @autobind
    public onSubmit(e: React.ChangeEvent<HTMLFormElement>) {
        this.submit();
        e.preventDefault();
    }

    @autobind
    public onCloseSubmit(e: React.ChangeEvent<HTMLFormElement>) {
        this.closeDialog();
        e.preventDefault();
    }

    public render() {
        const {isLoading} = this;
        const {classes} = this.props;
        return (
            <div>
                <Text>
Enter your Github username below and we will add you to the repository.
You can still do this step later by <a href="mailto:wcandillon@gmail.com" className={classes.link}>emailing us</a>.
                </Text>
                <form className={classes.form} onSubmit={this.onSubmit}>
                    <input
                        value={this.username}
                        type="text"
                        placeholder="Your Github account"
                        onChange={this.setUsername}
                        className={classes.input}
                        style={apparence}
                    />
                    <button disabled={isLoading} type="submit" color="primary" className={classes.btn}>
                    {
                        isLoading
                            ?
                                <CircularProgress size={16} classes={{ circle: classes.loading }} />
                            :
                                "Add me on Github"
                    }
                    </button>
                </form>
                <Dialog open={this.isDone} onClose={this.closeDialog}>
                    <DialogTitle>
                        {!this.error ? "We've added you to the repository" : "An error happened"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {
                                this.error && (
                                    <Text variant="important">
                                        We couldn't add you to the repository.
                                        Email addresses are invalid, only Github usernames are accepted.
                                    </Text>
                                )
                            }
                            {
                                !this.error && (
                                    <span>Happy Hacking <span style={{ color: "black" }}>🎉</span></span>
                                )
                            }
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <form onSubmit={this.onCloseSubmit}>
                            <Button
                                type="submit"
                                onClick={this.closeDialog}
                                primary={true}
                                autoFocus={true}
                            >
                            Ok
                            </Button>
                        </form>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default withStyles(styles)<GithubInviteProps>(GithubInvite);



// WEBPACK FOOTER //
// ./src/components/GithubInvite.tsx